import { render } from "./upIphone.vue?vue&type=template&id=0b3bc21a&scoped=true"
import script from "./upIphone.vue?vue&type=script&lang=js"
export * from "./upIphone.vue?vue&type=script&lang=js"

import "./upIphone.vue?vue&type=style&index=0&id=0b3bc21a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3bc21a"]])

export default __exports__